// Page Header
export const pageHeader = {
  title: "Store Tag",
  isEditorView: true,
  cancelPath: "storeTags",
  addPath: "storeTagEditor",
  buttonLabel: "Save",
};

// Page Header
export const listPageHeader = {
  title: "Store Tags",
  isEditorView: false,
  buttonLabel: "New",
  routerPath: "storeTagEditor",
};

export const filterCriteria = [
  {
    label: "Batch Id",
    code: "label",
    field: { type: "input", label: "Batch Id" },
    isPartial: true,
  },
  {
    label: "State Id",
    code: "tagIdMetrc",
    field: { type: "input", label: "State Id" },
    isPartial: true,
  },
  {
    label: "Group Type Name",
    code: "groupTagTypeName",
    field: { type: "input", label: "Group Tag Type" },
    isPartial: true,
  },
  {
    label: "Type Name",
    code: "tagTypeName",
    field: { type: "input", label: "Group Tag Type" },
    isPartial: true,
  },
  {
    label: "Tag Inventory Type Name",
    code: "tagInventoryTypeName",
    field: { type: "input", label: "Tag Inventory Type Name" },
    isPartial: true,
  },
];

export const columnHeaders = [
  {
    id: "open",
    type: "button",
    action: "navigateToEntity",
    iconName: "folder-open",
    ariaLabel: "Open",
  },
  {
    title: "Used",
    id: "isUsed",
    type: "checkbox",
  },
  {
    title: "Archived",
    id: "isArchived",
    type: "checkbox",
  },
  {
    title: "Label",
    id: "label",
    size: "large",
  },
  {
    title: "State",
    id: "state",
    size: "large",
  },
  {
    title: "State Id",
    id: "tagIdMetrc",
    size: "large",
  },
  {
    title: "Max Group Size",
    id: "maxGroupSize",
    size: "large",
  },
  {
    title: "Group Type Name",
    id: "groupTagTypeName",
    size: "large",
  },
  {
    title: "Type Name",
    id: "tagTypeName",
    size: "large",
  },
  {
    title: "Tag Inventory Type Name",
    id: "tagInventoryTypeName",
    size: "large",
  },
  {
    title: "Id",
    id: "_id",
  },
];

export const searchColumnHeaders = [
  {
    id: "select",
    type: "button",
    action: "selectItem",
    position: "sticky",
    iconName: "hand-pointer",
    ariaLabel: "Open",
  },
  {
    title: "Used",
    id: "isUsed",
    type: "checkbox",
  },
  {
    title: "Archived",
    id: "isArchived",
    type: "checkbox",
  },
  {
    title: "Label",
    id: "label",
  },
  {
    title: "State",
    id: "state",
  },
  {
    title: "State Id",
    id: "tagIdMetrc",
  },
  {
    title: "Max Group Size",
    id: "maxGroupSize",
  },
  {
    title: "Group Type Name",
    id: "groupTagTypeName",
  },
  {
    title: "Type Name",
    id: "tagTypeName",
  },
  {
    title: "Tag Inventory Type Name",
    id: "tagInventoryTypeName",
  },
  {
    title: "Id",
    id: "_id",
  },
];

export const storeTagInputs = [
  {
    id: 1,
    inputs: [
      {
        id: "label",
        placeholder: "Label",
        title: "Label",
      },
      {
        title: "State Id",
        id: "tagIdMetrc",
        placeholder: "State Id",
      },
      {
        id: "groupTagTypeName",
        placeholder: "Group Tag Type Name",
        title: "Group Tag Type Name",
      },
      {
        id: "groupTagTypeId",
        placeholder: "Group Tag Type Id",
        title: "Group Tag Type Id",
      },
      {
        id: "tagTypeName",
        placeholder: "Tag Type Name",
        title: "Tag Type Name",
      },
      {
        id: "tagTypeId",
        placeholder: "Tag Type Id",
        title: "Tag Type Id",
      },
      {
        id: "tagInventoryTypeName",
        placeholder: "Tag Inventory Type Name",
        title: "Tag Inventory Type Name",
      },
      {
        id: "maxGroupSize",
        placeholder: "Max Group Size",
        title: "Max Group Size",
      },
      {
        id: "metrcFacilityId",
        placeholder: "Facility Id",
        title: "Facility Id",
      },
      {
        title: "isUsed",
        id: "isUsed",
        placeholder: "Is Used",
        type: "checkBox",
        },
        {
            title: "Archived",
            id: "isArchived",
            placeholder: "Archived",
            type: "checkBox",
        },

    ],
  },
];

export const defaultSelectedStoreTag = {
  _id: "NEW",
};
